<template>
    <div v-if="!loading">
        <b-alert variant="danger" show>
            <p class="alert-body text-center">
                در صورتی عنوان ویژگی ویرایش شود که معنا و مفهوم و کارایی اون ویژگی تغییر نکند.
            </p>
        </b-alert>
        <div class="pb-3">
            <div v-for="(featureGroup, featureGroupIndex) in featureGroups" :key="featureGroupIndex">
                <div class="p-1 text-white bg-info border rounded mt-2">{{ featureGroup.title }}</div>
                <b-card no-body v-for="(feature, featureIndex) in featureGroup.features"
                    class="feature-item-page-features rounded"
                    :class="{ 'feature-item-page-features-active': secondFeatureSelected.title == feature.title || firstFeatureSelected.title == feature.title }"
                    :key="featureIndex">
                    <div class="p-1">{{ feature.title }}</div>
                    <div @click="handlingChangeOrder(featureGroup.key, feature)"
                        class="d-flex justify-content-center pointer">
                        <feather-icon icon="RepeatIcon" size="18" class="text-info" />
                    </div>
                    <div @click="editFeature(featureGroup.key, feature)" class="d-flex justify-content-center pointer">
                        <feather-icon icon="EditIcon" size="18" class="text-info" />
                    </div>
                </b-card>
            </div>
        </div>

        <!-- Edit modal -->
        <b-modal id="modal-edit-feature" title="ویرایش ویژگی" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <b-card-text class="p-1">
                <div>
                    <h6>نام ویژگی</h6>
                    <b-form-input class="text-center" v-model="form.title" />
                </div>
                <b-button @click="subscriptionFeaturesUpdate" class="w-100 mt-2" variant="primary">
                    ویرایش
                </b-button>
            </b-card-text>
        </b-modal>

    </div>
</template>

<script>
import { BCard, BCardText, BButton, BFormInput, BModal, BAlert } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BFormInput,
        BModal,
        BAlert
    },
    data() {
        return {
            loading: true,
            featureGroups: [],
            form: {
                key: null,
                title: null,
                order: null,
                groupKey: null
            },
            firstFeatureSelected: {},
            secondFeatureSelected: {},
        };
    },
    methods: {
        handlingChangeOrder(featureGroupKey, feature) {
            if (this.firstFeatureSelected.title == undefined) {
                this.firstFeatureSelected = feature;
                this.firstFeatureSelected.groupKey = featureGroupKey;
            }
            else {
                this.secondFeatureSelected = feature;
                this.secondFeatureSelected.groupKey = featureGroupKey;
                this.form.key = this.firstFeatureSelected.key
                this.form.title = this.firstFeatureSelected.title
                this.form.order = this.secondFeatureSelected.order
                this.form.groupKey = this.secondFeatureSelected.groupKey
                this.subscriptionFeaturesChangeOrder()
            }
        },
        getSubscriptionsFeatures() {
            this.loading = true
            adminService.subscriptionFeatures().then(({ data }) => {
                this.featureGroups = data.groups
                this.loading = false
            })
        },
        subscriptionFeaturesChangeOrder() {
            adminService.subscriptionFeaturesUpdate(this.form).then(({ data }) => {
                this.form.key = this.secondFeatureSelected.key
                this.form.title = this.secondFeatureSelected.title
                this.form.order = this.firstFeatureSelected.order
                this.form.groupKey = this.firstFeatureSelected.groupKey
                this.subscriptionFeaturesUpdate()
            })
                .catch(() => {
                    this.form.key = null
                    this.form.order = null
                    this.form.title = null
                    this.form.groupKey = null
                    this.firstFeatureSelected = {}
                    this.secondFeatureSelected = {}
                    this.$notif({ type: 'error' });
                });
        },
        subscriptionFeaturesUpdate() {
            adminService.subscriptionFeaturesUpdate(this.form).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.form.key = null
                this.form.order = null
                this.form.title = null
                this.form.groupKey = null
                this.firstFeatureSelected = {}
                this.secondFeatureSelected = {}
                this.getSubscriptionsFeatures();
            })
        },
        editFeature(featureGroupKey, feature) {
            this.form.key = feature.key
            this.form.order = feature.order
            this.form.title = feature.title
            this.form.groupKey = featureGroupKey
            this.$bvModal.show('modal-edit-feature')
        },
    },
    mounted() {
        this.getSubscriptionsFeatures();
    }
};
</script>


<style lang="scss">
.feature-item-page-features {
    display: grid;
    grid-template-columns: 6fr repeat(2, 1fr);
    align-items: center;
    margin: 13px 0 0 0 !important;
    border: 2px solid #ffffff00;

    &-active {
        border: 2px solid #7166f0 !important;
    }
}
</style>